import React, { useCallback, useEffect } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import {
  Button,
  Checkbox,
  FormControl,
  Grid,
  MenuItem,
  Paper,
  Select,
  TextField,
  DialogActions,
  Autocomplete,
  Menu,
  InputLabel,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import Div from "@jumbo/shared/Div";
import * as Yup from "yup";
import { useState } from "react";
import moment from "moment";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";

const CustomToolbar = () => {
  return (
    <GridToolbarContainer>
      <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
    </GridToolbarContainer>
  );
};

const ReportPurchaseOrSalesOutstanding = () => {
  const swal = useSwalWrapper();
  const [HelperData, setHelperData] = useState([]);
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState(false);

  const [formval, setFormval] = useState({
    selectedParties: "",
    startDate: "",
    endDate: "",
    salesmanData: "",
    transactionType: "",
    P_curr: "",
  });

  const columns = [
    {
      field: "FL_TRANS_DATE",
      headerName: "Trans Date",
      width: 185,
    },
    { field: "FL_BILL_NO", headerName: "Bill No", width: 185 },
    { field: "PARTY_NAME", headerName: "Party Name", width: 185 },
    { field: "TRANS_TYPE", headerName: "Trans Type", width: 185 },
    { field: "TERM_NAME", headerName: "Term Name", width: 185 },
    {
      field: "DUE_DATE",
      headerName: "Due Date",
      width: 185,
    },
    {
      field: "INV_AMT",
      headerName: "Inv Amount",
      width: 185,
      renderCell: ({ value }) => value.toFixed(2),
    },
    {
      field: "PAID_AMT",
      headerName: "Paid Amount",
      width: 185,
      renderCell: ({ value }) => value.toFixed(2),
    },
    { field: "EARLY_DUE", headerName: "Early Due", width: 185 },
    {
      field: "BALANCE",
      headerName: "Balance",
      width: 185,
      renderCell: ({ value }) => value.toFixed(2),
    },
  ];

  const validationSchema = Yup.object().shape({
    transactionType: Yup.string().required("TransactionType is required"),
    startDate: Yup.string().required("Start Date is required"),
    endDate: Yup.string().required("End Date is required"),
    P_curr: Yup.string().required("Currency is required"),
  });

  const fetchtrPartydata = useCallback(() => {
    jwtAuthAxios
      .get("master/helper?salesman=1&Vendor=1&party=1&curr=1")
      .then((res) => {
        setHelperData(res.data.data);
      })
      .catch(alert);
  });

  useEffect(() => {
    let isMounted = true;

    fetchtrPartydata();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleSubmit = async (values, { setSubmitting }) => {
    await jwtAuthAxios
      .post("/accreport/outstandingreport", values)
      .then((res) => {
        if (res.data?.status == "success") {
          setRows(res.data?.data);
        } else {
          swal.fire({
            icon: "error",
            text: res.data.message,
          });
        }
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "something Went Wrong",
        });
      });
    setStatus(true);
    setSubmitting(false);
  };

  const handlePdf = async (values) => {
    let payload = {
      P_PARTY_CODE: values.p_party_code,
      p_frdt: moment(values.startDate).format("DD/MM/YYYY"),
      p_todt: moment(values.endDate).format("DD/MM/YYYY"),
      P_sales_person: values.salesmanData,
      p_trans_type: values.transactionType == "PURCHASE" ? "26" : "35",
      P_curr: values.P_curr,
    };
    await jwtAuthAxios
      .post("/accreport/reporting", {
        data: payload,
        desformat: "PDF",
        report: "Outstanding_rep.rdf",
        outfile: "ACC_LEDGER.pdf",
      })
      .then((res) => {
        if (res?.status == 200) {
          window.open(`https://admin.blossomdiam.com${res.data}`);
        } else {
          swal.fire({
            icon: "error",
            text: res.data.message,
          });
        }
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "something Went Wrong",
        });
      });
  };
  return (
    <div style={{ padding: "20px" }}>
      <JumboCardQuick title={"Purchase/Sales Outstanding"}>
        <Paper elevation={0}>
          <Formik
            initialValues={formval}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting }) => {
              await handleSubmit(values, { setSubmitting });
            }}
          >
            {({
              values,
              handleChange,
              setValues,
              setFieldValue,
              isSubmitting,
            }) => (
              <Form>
                <Grid container spacing={3}>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth margin="normal" sx={{ mt: 0 }}>
                      <Autocomplete
                        id="TR-type"
                        size="small"
                        options={["PURCHASE", "SALES"]}
                        disableCloseOnSelect
                        value={values.transactionType}
                        name="transactionType"
                        onChange={(event, newValue) => {
                          setFieldValue("selectedParties", "");
                          setValues({
                            ...values,
                            transactionType: newValue,
                          });
                        }}
                        defaultValue={["PURCHASE", "SALES"]?.filter((p) =>
                          values.transactionType?.includes(p)
                        )}
                        getOptionLabel={(option) =>
                          Array.isArray(option) ? "" : option
                        }
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              icon={
                                <CheckBoxOutlineBlankIcon fontSize="small" />
                              }
                              checkedIcon={<CheckBoxIcon fontSize="small" />}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Transaction Type"
                            placeholder="..."
                          />
                        )}
                      />
                      <ErrorMessage
                        name="transactionType"
                        component="div"
                        style={{
                          color: "red",
                          fontSize: "14px",
                          marginTop: "4px",
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth margin="normal" sx={{ mt: 0 }}>
                      <Select
                        size="small"
                        id="PartyId"
                        value={values.selectedParties || []}
                        onChange={handleChange}
                        name="selectedParties"
                        displayEmpty
                        renderValue={
                          values.selectedParties != ""
                            ? undefined
                            : () => <InputLabel>Party</InputLabel>
                        }
                      >
                        <MenuItem value="" disabled>
                          Select Party
                        </MenuItem>
                        {values.transactionType === "SALES" &&
                          HelperData.PARTY?.map((party) => (
                            <MenuItem
                              key={party.FL_PARTY_CODE}
                              value={party.FL_PARTY_CODE}
                            >
                              {party.FL_PARTY_NAME}
                            </MenuItem>
                          ))}
                        {values.transactionType === "PURCHASE" &&
                          HelperData.VENDOR?.map((vendor) => (
                            <MenuItem
                              key={vendor.FL_PARTY_CODE}
                              value={vendor.FL_PARTY_CODE}
                            >
                              {vendor.FL_PARTY_NAME}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth margin="normal" sx={{ mt: 0 }}>
                      <Autocomplete
                        size="small"
                        id="salesmanData-type"
                        options={HelperData?.SALESMAN || []}
                        disableCloseOnSelect
                        onChange={(event, newValue) => {
                          setValues({
                            ...values,
                            salesmanData: newValue?.FL_USER_ID,
                          });
                        }}
                        getOptionLabel={(option) => option.FL_NAME}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>{option.FL_NAME}</li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Salesman "
                            placeholder="..."
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      margin="normal"
                      type="date"
                      label="Start Date"
                      name="startDate"
                      value={values.startDate}
                      InputLabelProps={{ shrink: true }}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="startDate"
                      component="div"
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "4px",
                      }}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      margin="normal"
                      type="date"
                      label="End Date"
                      InputLabelProps={{ shrink: true }}
                      name="endDate"
                      value={values.endDate}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      name="endDate"
                      component="div"
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "4px",
                      }}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth margin="normal">
                      <Select
                        size="small"
                        id="P_curr"
                        value={values.P_curr || []}
                        onChange={handleChange}
                        name="P_curr"
                        displayEmpty
                        renderValue={
                          values.P_curr != ""
                            ? undefined
                            : () => <InputLabel>Currency</InputLabel>
                        }
                      >
                        <MenuItem value="" disabled>
                          Select Currency
                        </MenuItem>
                        {HelperData.CURR?.map((party) => (
                          <MenuItem
                            key={party.FL_CURRENCY_ID}
                            value={party.FL_CURRENCY_ID}
                          >
                            {party.FL_CURRENCY_NAME}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <ErrorMessage
                      name="P_curr"
                      component="div"
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "4px",
                      }}
                    />
                  </Grid>
                </Grid>

                <DialogActions>
                  <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    disabled={isSubmitting}
                  >
                    Search
                  </Button>
                  {status && (
                    <Div>
                      <PopupState variant="popover" popupId="demo-popup-menu">
                        {(popupState) => (
                          <React.Fragment>
                            <Button
                              variant="contained"
                              {...bindTrigger(popupState)}
                            >
                              Exports
                            </Button>
                            <Menu {...bindMenu(popupState)}>
                              <MenuItem onClick={() => handlePdf(values)}>
                                Pdf
                              </MenuItem>
                            </Menu>
                          </React.Fragment>
                        )}
                      </PopupState>
                    </Div>
                  )}
                </DialogActions>
              </Form>
            )}
          </Formik>
        </Paper>
      </JumboCardQuick>
      {status && (
        <div style={{ height: 300, width: "100%", marginTop: "30px" }}>
          <JumboCardQuick>
            <Paper elevation={0}>
              <DataGrid
                rows={rows}
                getRowId={(e) => e.FL_BILL_NO}
                columns={columns}
                slots={{
                  toolbar: CustomToolbar,
                }}
              />
            </Paper>
          </JumboCardQuick>
        </div>
      )}
    </div>
  );
};

ReportPurchaseOrSalesOutstanding.Modulename = "expensepayment";

export default ReportPurchaseOrSalesOutstanding;
